import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import moment from "moment";


import "./RegisterPlugins";
import "./assets/css/main.css";


Vue.config.productionTip = false;

new Vue({
    router: router,
    store,
    beforeCreate: function() {
        /// if set lang identifier into url set it as site current lang

        if (this.$route.name && _.size(this.$route.name) >= 2) {
            this.$store.commit("main/setState", {
                key: "locale",
                val: this.$route.name.slice(-2)
            });
        }

        /// set ajax default request lang
        axios.defaults.headers.common["lang"] = this.$store.state.main.locale;

        if (this.$route.query.preview)
            this.$cookies.set("siteMode", this.$route.query.preview, "1d");

        /// load site main data
        this.$store.dispatch("main/indx");
    },

    mounted() {
        window.scrollTo(0, 0);
        /*setTimeout(enable, 500)*/
    },
    watch: {
        "$route.name": {
            immediate: true,
            handler() {
                // return false;
                /// set selected locale
                /// set axios default header for selected language
                /// send main request to server

                if (!this.$route.name) return false;

                /// if set lang identifier into url set it as site current lang
                if (this.$route.name && _.size(this.$route.name) >= 2) {
                    this.$store.commit("main/setState", {
                        key: "locale",
                        val: this.$route.name.slice(-2)
                    });
                }

                /// set ajax default request lang
                axios.defaults.headers.common["lang"] = this.$store.state.main.locale;

                this.$store.commit("main/setMenuFullUrls");

                if (this.$cookies.get("siteMode"))
                    axios.defaults.headers.common["siteMode"] = this.$cookies.get(
                        "siteMode"
                    );

                /// load indx part after every language change
                this.$store.dispatch("main/indxTranslatable");

                /// loads only once
                this.$store.dispatch("main/getTranslations");
            }
        },
        "$store.state.main.locale": {
            immediate: true,
            handler: function(val) {

            }
        }
    },
    methods: {

    },

    render: h => h(App)
}).$mount("#app");